import React from 'react'

const Footer = () => {
  return (<footer className="site-footer">
    <div className="column text-center">
      <h3 className="widget-title text-center">Contacto
        <small>+54 9 221 4645569/70</small>
        <small>De lunes a viernes de 9 a 14 hs.</small>
      </h3>
      <a className="social-button sb-facebook"
        href="https://www.facebook.com/municipiodeberisso"
        data-toggle="tooltip"
        data-placement="top"
        title="Facebook">
        <i className="socicon-facebook"/>
      </a>
    </div>
    <div className="column">
      <h3 className="widget-title text-center">
                Links de interés
          <small><a href="http://www.berisso.gov.ar/">Municipalidad de Berisso</a></small>
          <small><a href="https://www.epagos.com.ar/">E-pagos</a></small>
      </h3>
    </div>
  </footer>)
}

export default Footer
